module.exports = __webpack_public_path__ + "static/media/wizualizacja-16.3f893d43.png";